import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import { CloseOutlined, SendOutlined } from '@ant-design/icons';
import telemedActions from '../../redux/telemed/actions';
import { formatMessageTime, sortMessages } from '../../helpers/telemedCall';
import './style.css';

// Chat escuro da chamada, usado pelo paciente (/t) e pelo modal do profissional.
function ChatPanel({ onClose, compact }) {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.Telemed.telemedChatMessages);
  const userType = useSelector((state) => state.Telemed.userType);
  const dataChannelOpen = useSelector((state) => state.Telemed.dataChannelOpen);
  const [draft, setDraft] = useState('');
  const listRef = useRef(null);
  const ordered = sortMessages(messages);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [ordered.length]);

  const send = () => {
    const text = draft.trim();
    if (!text || !dataChannelOpen) {
      return;
    }
    dispatch(telemedActions.sendChatMessage(userType, text));
    setDraft('');
  };

  return (
    <div className={`tmchat${compact ? ' tmchat-compact' : ''}`}>
      <div className="tmchat-head">
        <span className="tmchat-title">Mensagens</span>
        <button
          type="button"
          className="tmchat-close"
          aria-label="Fechar mensagens"
          onClick={onClose}
        >
          <CloseOutlined />
        </button>
      </div>

      <div className="tmchat-list" ref={listRef}>
        {ordered.length === 0 ? (
          <span className="tmchat-empty">
            As mensagens trocadas durante a consulta aparecem aqui.
          </span>
        ) : null}
        {ordered.map((message) => (
          <div
            className={`tmchat-msg${message.userType === userType ? ' tmchat-msg-own' : ''}`}
            key={message.id || `${message.timestamp}-${message.text}`}
          >
            <span className="tmchat-msg-text">{message.text}</span>
            <span className="tmchat-msg-time">
              {message.sendingNewMessage ? 'Enviando…' : formatMessageTime(message.timestamp)}
            </span>
          </div>
        ))}
      </div>

      <div className="tmchat-form">
        <Input
          value={draft}
          placeholder="Escreva uma mensagem"
          disabled={!dataChannelOpen}
          onChange={(event) => setDraft(event.target.value)}
          onPressEnter={send}
        />
        <Button
          type="primary"
          icon={<SendOutlined />}
          aria-label="Enviar mensagem"
          disabled={!dataChannelOpen}
          onClick={send}
        />
      </div>
    </div>
  );
}

export default ChatPanel;
